import { Dtos, IndemnityAgreementSignatureMethod } from "@inrev/common";
import { z } from "zod";

export const getBondIssuanceFormValidationSchema = (context: {
	allowedIssuanceMethods: Dtos.SuretyBondIssuance.Get.Response["allowedIssuanceMethods"];
	indemnityAgreement: Dtos.SuretyAccount.IndemnityAgreement.Get.Response | null | undefined;
	indemnitors: Dtos.SuretyAccount.IndemnityAgreement.Get.Response["indemnitors"];
	allowedSignatureMethods: IndemnityAgreementSignatureMethod[];
}) => {
	const bondFormBaseSchema = Dtos.SuretyBondIssuance.Contract.Create.Request.schema.refine((data) =>
		context.allowedIssuanceMethods.includes(data.issuanceMethod),
	);

	if (!context.indemnityAgreement) {
		const indemnityAgreementSchema = Dtos.IndemnityAgreement.Create.Request.schema.refine(
			(data) => {
				return (
					context.allowedSignatureMethods.includes(data.signatureMethod) &&
					context.indemnitors.companies.length === data.companySigners.length &&
					data.companySigners.every((signer) =>
						context.indemnitors.companies.some((company) => company.id === signer.contactId),
					) &&
					context.indemnitors.individuals.length === data.individualSigners.length &&
					data.individualSigners.every((signer) =>
						context.indemnitors.individuals.some(
							(individual) => individual.id === signer.contactId,
						),
					)
				);
			},
		);
		return z.object({ bondForm: bondFormBaseSchema, indemnityAgreement: indemnityAgreementSchema });
	}
	return z.object({ bondForm: bondFormBaseSchema });
};
